/**
 * Detect touch devices
 */

export default 'ontouchstart' in document.documentElement || 'ontouchstart' in window || navigator.msMaxTouchPoints;
